import React from 'react'
import { inject, observer } from 'src/core/store'
import './index.less'
import http from 'src/helper/http'
import { getlangV2, setlang } from 'src/helper/getlang'
import { setDocumentTitle, setUidToken, isRtl, isVoca } from 'src/helper/tool'
import lang from './lang'
import Toast from '../../../component/Toast'
import { jumpToUser } from 'src/helper/webviewFun'
@inject('store')
@observer
export default class extends React.Component {
  constructor(props) {
    super(props)
    this.duidStore = this.props.store.register('app/duid')
  }
  state = {
    language: 'en',
    lang: lang.en,
    inLoading: false,
    showRulesOrCbValue: true,
    showModalRoot: false,
    userInfo: {},
    selectSpeakNumList: [],
    scroll: '0,12',
    toastContent: '最多选择4个不同的数字',
    hasMore: false,
    totalCount: 0,
    speakList: [],
    lastScrpll: [],
    showWhiteModal: false,
    selectSpeakIndex: -1,
    step: {
      tr: '/img/app/duid2/step_img_tr.png',
      ar: '/img/app/duid2/step_img_ar.png',
      en: '/img/app/duid2/step_img.png',
      pt: '/img/app/duid2/step_img.png',
      id: '/img/app/duid2/step_img.png',
    },
    stepTwo: {
      tr: '/img/app/duid2/step_two_img_tr.png',
      ar: '/img/app/duid2/step_two_img_ar.png',
      en: '/img/app/duid2/step_two_img.png',
      pt: '/img/app/duid2/step_two_img.png',
      id: '/img/app/duid2/step_two_img.png',
    },
    ruleImg: {
      tr: '/img/app/duid2/rules_big_text_tr.png',
      ar: '/img/app/duid2/rules_big_text_ar.png',
      en: '/img/app/duid2/rules_big_text.png',
      pt: '/img/app/duid2/rules_big_text.png',
      id: '/img/app/duid2/rules_big_text.png',
    },
    bannerImg: {
      ar: '/img/app/duid2/banner_img_ar.png',
      fa: '/img/app/duid2/banner_img_fa.png',
      id: '/img/app/duid2/banner_img_id.png',
      pt: '/img/app/duid2/banner_img_pt.png',
      ru: '/img/app/duid2/banner_img_ru.png',
      tr: '/img/app/duid2/banner_img_tr.png',
      ur: '/img/app/duid2/banner_img_ur.png',
      uz: '/img/app/duid2/banner_img_uz.png',
      en: '/img/app/duid2/banner_img.png',
    },
    idsbw: [
      'https://h5-activity.yayya.live/img/app/duid2/new_btn_bg.png',
      'https://h5-activity.yayya.live/img/app/duid2/zero_had_bg.png',
      'https://h5-activity.yayya.live/img/app/duid2/Group_in.png',
    ],
  }

  async componentWillMount() {
    let { language } = this.props.location.query
    language = await getlangV2(language, lang)
    const currentLang = setlang(language, lang)
    if (isVoca()) {
      for (let key in currentLang) {
        if (currentLang[key] && typeof currentLang[key] === 'string') {
          currentLang[key] = currentLang[key].replace(/(Yayya|hoby)/, 'Voca')
        }

        if (Array.isArray(currentLang[key])) {
          currentLang[key] = currentLang[key].map((item) => {
            if (typeof item === 'string') {
              return item.replace(/(Yayya|hoby)/, 'Voca')
            }
            return item
          })
        }
      }
    }
    this.setState({
      lang: currentLang,
      language: language,
    })
    setDocumentTitle(this.state.lang.domTitle)
    let uid = await setUidToken(this.props.location.query)
    this.getUserInfo()
    await this.RunOnStart(uid)
  }

  // 需要uid才能执行的操作
  RunOnStart = async (uid) => {
    this.setState({
      uid: uid,
      popRecord: false,
    })
  }

  componentDidMount() {}

  componentDidUpdate(prevProps, prevState) {
    if (this.state.showModalRoot && !prevState.showModalRoot) {
      this.lockBodyScroll()
    } else if (!this.state.showModalRoot && prevState.showModalRoot) {
      this.unlockBodyScroll()
    }
  }

  componentWillUnmount() {
    this.unlockBodyScroll()
  }

  lockBodyScroll = () => {
    try {
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
      this._scrollTop = scrollTop
      const body = document.body
      body.style.position = 'fixed'
      body.style.top = `-${scrollTop}px`
      body.style.left = '0'
      body.style.right = '0'
      body.style.width = '100%'
      body.style.overflow = 'hidden'
    } catch (e) {}
  }

  unlockBodyScroll = () => {
    try {
      const body = document.body
      body.style.position = ''
      body.style.top = ''
      body.style.left = ''
      body.style.right = ''
      body.style.width = ''
      body.style.overflow = ''
      if (typeof this._scrollTop === 'number') {
        window.scrollTo(0, this._scrollTop || 0)
        this._scrollTop = 0
      }
    } catch (e) {}
  }

  getUserInfo = async (uid) => {
    let res = await http.post('/web/MyAccountInfo', { uid })
    console.log(res)
    if (res.code === 0) {
      this.setState({ userInfo: res.data })
    }
  }
  showRulesOrCb = (e) => {
    this.setState({ showRulesOrCbValue: e })
  }

  closeModal = (e) => {
    e.stopPropagation()
    this.setState({ showModalRoot: false, scroll: '0,12', lastScrpll: [] })
  }

  handleNextBtn = async () => {
    let { selectSpeakNumList, userInfo, lang } = this.state
    if (selectSpeakNumList.length <= 1) return
    if (userInfo.wealthLv < 25) {
      await this.setState({ toastContent: lang.notwoFive })
      return this.refs.toast.hideRule(true)
    }
    if (userInfo.canChangeDuidTimes === 0) {
      await this.setState({ toastContent: lang.tiemZero })
      return this.refs.toast.hideRule(true)
    }
    if (selectSpeakNumList.length === 1 && selectSpeakNumList[0] === 0) {
      await this.setState({ toastContent: lang.fistNumZreo })
      return this.refs.toast.hideRule(true)
    }
    if (selectSpeakNumList.length === 2 && userInfo.wealthLv < 45) {
      await this.setState({ toastContent: lang.notFourFive })
      return this.refs.toast.hideRule(true)
    }
    if (selectSpeakNumList.length === 1 && selectSpeakNumList[0] !== 0 && userInfo.wealthLv < 50) {
      await this.setState({ toastContent: lang.notFivety })
      return this.refs.toast.hideRule(true)
    }
    await this.getSpeakIdList(1)
    await this.setState({ showModalRoot: true })
  }

  getSpeakIdList = async (i = 1) => {
    let { selectSpeakNumList, scroll, lastScrpll, speakList } = this.state
    let duid = selectSpeakNumList.join('')
    let getscroll = i === 2 ? lastScrpll[lastScrpll.length - 2] : scroll
    let res = await http.post('/web/duid/duidlistnew', { scroll: getscroll, duid })
    if (res.code === 0) {
      let now = lastScrpll
      if (i === 1) {
        now.push(getscroll)
      } else if (scroll !== '0,12' && i === 2) {
        now.pop()
      }
      const newSpeakList =
        i === 1 ? [...(speakList || []), ...(res.data.list || [])] : res.data.list || []
      await this.setState({
        speakList: newSpeakList,
        totalCount: res.data.totalCount,
        scroll: res.data.scroll,
        hasMore: res.data.hasMore,
        lastScrpll: now,
        selectSpeakIndex: -1,
      })
    }
  }

  getPageList = (e) => {
    this.getSpeakIdList(e)
  }

  selectSpeakNum = async (num) => {
    let { selectSpeakNumList, lang } = this.state
    let indexs = selectSpeakNumList.indexOf(num)
    if (selectSpeakNumList.length >= 4 && indexs === -1) {
      await this.setState({ toastContent: lang.bigFour })
      this.refs.toast.hideRule(true)
      return
    }
    if (indexs === -1) {
      selectSpeakNumList.push(num)
    } else {
      selectSpeakNumList.splice(indexs, 1)
    }
    await this.setState({ selectSpeakNumList })
  }

  handleIndex = (e) => {
    let { selectSpeakIndex } = this.state
    this.setState({ selectSpeakIndex: e === selectSpeakIndex ? -1 : e })
  }

  hanldeCheckId = () => {
    let { selectSpeakIndex } = this.state
    if (selectSpeakIndex === -1) return
    this.setState({ showWhiteModal: true })
  }

  // 列表滚动到底部加载下一页
  onSpeakListScroll = async (e) => {
    try {
      const { hasMore, inLoading } = this.state
      const target = e.target
      const { scrollTop, clientHeight, scrollHeight } = target
      const threshold = 10 // 距底部 10px 内触发
      const nearBottom = scrollTop + clientHeight >= scrollHeight - threshold
      if (nearBottom && hasMore && !inLoading) {
        await this.setState({ inLoading: true })
        await this.getSpeakIdList(1)
        await this.setState({ inLoading: false })
      }
    } catch (err) {
      // 忽略滚动触发异常，避免影响 UI
      this.setState({ inLoading: false })
    }
  }

  getSpeakIdReqset = async () => {
    try {
      let { selectSpeakIndex, speakList, lang } = this.state
      let duid = speakList[selectSpeakIndex] + ''
      let res = await http.post('/web/duid/requestDuidStr', { duid })
      if (res.code === 0) {
        await this.setState({
          toastContent: lang.useOk,
          showWhiteModal: false,
          showModalRoot: false,
          scroll: '0,12',
          lastScrpll: [],
        })
        this.refs.toast.hideRule(true)
        this.getUserInfo()
      } else if (res.code !== 0 && typeof res.code === 'number') {
        await this.setState({ toastContent: res.msg, showWhiteModal: false })
        return this.refs.toast.hideRule(true)
      } else {
        await this.setState({ toastContent: lang.useError + res.msg, showWhiteModal: false })
        return this.refs.toast.hideRule(true)
      }
    } catch (error) {
      await this.setState({ toastContent: lang.useError, showWhiteModal: false })
      return this.refs.toast.hideRule(true)
    }
  }

  render() {
    let {
      showWhiteModal,
      speakList,
      toastContent,
      selectSpeakNumList,
      userInfo,
      showModalRoot,
      language,
      showRulesOrCbValue,
      lang,
      selectSpeakIndex,
      bannerImg,
      idsbw,
    } = this.state
    return (
      <div className={`hobiduid inthepage_one ${isRtl(language) ? 'arlang' : ''}`}>
        <Toast language={language} lang={lang} ref="toast" id="toast" toastContent={toastContent} />
        <div className="banner-hobiduid">
          <img className="banner-img" src={bannerImg[language] || bannerImg.en}></img>
          {showRulesOrCbValue && (
            <div className="rule-btn" onClick={() => this.showRulesOrCb(false)}>
              {lang.rulesText}
            </div>
          )}
          <div style={{ height: '1px', width: '1px', overflow: 'hidden' }}>
            <img style={{ height: '1px' }} src={idsbw[0]}></img>
            <img style={{ height: '1px' }} src={idsbw[1]}></img>
            <img style={{ height: '1px' }} src={idsbw[2]}></img>
          </div>
        </div>

        <div className="content-box">
          <div className="show-user-info" onClick={() => jumpToUser(userInfo.uid)}>
            <div className="user-atv">
              <img className="img-head" src="/img/app/duid2/head-bg.png" />
              <img src={userInfo.avatarurl} className="usr-head-img"></img>
            </div>
            <div style={{ width: '12px', height: '100%', flexShrink: 0 }}></div>
            <div className="user-info-text">
              <div className="item">
                <div className="title">{lang.nickname}：</div>
                <div className="text" style={{ color: '#FFFFFF' }}>
                  {userInfo.nickname}
                </div>
              </div>
              <div className="item">
                <div className="title">{lang.wealthlevel}：</div>
                <div className="text" style={{ color: '#FFFFFF' }}>
                  {userInfo.wealthLv}
                </div>
              </div>
              <div className="item">
                <div className="title">{lang.domTitle}：</div>
                <div className="text" style={{ color: '#FFEC3F' }}>
                  {userInfo.duidLv === 0 || userInfo.uid === userInfo.duid ? '-' : userInfo.duid}
                </div>
              </div>
              <div className="item">
                <div className="title">{lang.Redeemabletimes}：</div>
                <div className="text" style={{ color: '#FFEC3F' }}>
                  {userInfo.canChangeDuidTimes}
                </div>
              </div>
            </div>
          </div>
          <div className="show-select-root">
            {/* <img
                className="step-img"
                style={{ [isRtl(language) ? 'right' : 'left']: '0.4rem' }}
                src={step[language] || step.en}
              ></img> */}
            <div className="ssr-title">create your number</div>
            <div
              className="tips"
              style={{
                [isRtl(language) ? 'marginLeft' : 'marginRight']: '0rem',
                textAlign: `${isRtl(language) ? 'center' : 'center'}`,
              }}
            >
              {lang.selectTip}
            </div>
            <div className="num-root">
              <div
                className={`num-root-right ${selectSpeakNumList.includes(0) ? 'in-zro-num' : 'no-zor-num'}`}
                onClick={() => this.selectSpeakNum(0)}
              >
                0
              </div>
              <div className="num-root-left">
                {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((item) => (
                  <div
                    key={item}
                    className={`item ${selectSpeakNumList.includes(item) ? 'in-had-num' : 'no-had-num'}`}
                    onClick={() => this.selectSpeakNum(item)}
                  >
                    {item}
                  </div>
                ))}
              </div>
            </div>

            <div
              className={`next-btn ${selectSpeakNumList.length > 1 ? 'had-next-btn' : 'no-newx-btn'}`}
              onClick={(e) => this.handleNextBtn()}
            >
              {lang.Next}
            </div>

            <div className="select-num-tips">{lang.tipInselect}</div>
          </div>
        </div>

        {!showRulesOrCbValue && (
          <div className="yayya-app-modal" onClick={(e) => e.stopPropagation()}>
            <div className="rule-detail">
              <div className="rules-text">
                <div className="rules-content-title">{lang.rulesText}</div>
                <div className="rules-content-text">
                  <div>{lang.rulesCoentenTextOne}</div>
                  <div>{lang.rulescoenTwo}</div>
                  <div>{lang.rulescoenThree}</div>
                  <div>{lang.rulescoenFour}</div>
                  <div>{lang.rulescoenFive}</div>
                  <div>{lang.rulescoenSix}</div>
                </div>

                <img
                  className="cb-show-arow"
                  onClick={() => this.showRulesOrCb(true)}
                  src="/img/app/duid2/ruel_cb_bg.png"
                ></img>
              </div>
            </div>
          </div>
        )}
        <div className="call-me-tips">
          <div>{lang.tipInpageOne}</div>
          <div>{lang.tipInpageTwo}</div>
        </div>
        {showModalRoot && (
          <div className="next-modal" onClick={(e) => e.stopPropagation()}>
            <div>
              {speakList.length > 0 && (
                <div className="speak-id-roole">
                  <div className="title-select">{lang.Choosepretty}</div>
                  <div className="title-tips">{lang.showYouCanuse}</div>
                  <div>
                    <div className="show-speakid-root" onScroll={this.onSpeakListScroll}>
                      {speakList.length > 0 &&
                        speakList.map((item, index) => (
                          <div
                            onClick={() => this.handleIndex(index)}
                            className={`index-speak-id ${
                              selectSpeakIndex === index ? 'in-the-select-time' : 'no-the-time'
                            }`}
                            key={item}
                          >
                            {item}
                          </div>
                        ))}
                      <div className="index-speak-id"></div>
                      <div className="index-speak-id"></div>
                    </div>
                    {/* <div className="arrow-root">
                      <div className="arrow-root-left">
                        {lastScrpll.length > 1 && (
                          <img
                            className="arrow-root-left"
                            src="/img/app/duid2/arrow_left.png"
                            onClick={() => this.getPageList(2)}
                          ></img>
                        )}
                      </div>
                      <div className="arrow-root-right">
                        {hasMore && (
                          <img
                            className="arrow-root-right"
                            src="/img/app/duid2/arrow_right.png"
                            onClick={() => this.getPageList(1)}
                          ></img>
                        )}
                      </div>
                    </div> */}
                    {/* <div
                      onClick={() => this.hanldeCheckId()}
                      className={`select-submit-btn ${selectSpeakIndex !== -1 ? 'inhadselectbtn' : 'nohadselectbtn'}`}
                    >
                      {lang.Confirm}
                    </div> */}
                  </div>

                  <div className="pretty_btn">
                    <div className="pretty_btn_cancel" onClick={(e) => this.closeModal(e)}>
                      {lang.Cancel}
                    </div>
                    <div className="pretty_btn_confirm" onClick={() => this.hanldeCheckId()}>
                      {lang.Confirm}
                    </div>
                  </div>
                </div>
              )}
              {speakList.length === 0 && (
                <div className="speak-id-roole-empty">
                  {/* <img
                    className="step-two"
                    style={{ [isRtl(language) ? 'right' : 'left']: '0.36rem' }}
                    src="/img/app/duid2/step_two_img.png"
                  ></img> */}
                  <div className="title-select">{lang.Choosepretty}</div>
                  {/* <div className="title-tips">{lang.showYouCanuse}</div> */}
                  <div className="no-had-empty">
                    <img className="empty-img" src="/img/app/duid2/nochanges_zro.png"></img>
                    <div className="empty-tips">{lang.useEmpty}</div>
                  </div>

                  <div className="pretty_btn">
                    <div className="pretty_btn_confirm" onClick={(e) => this.closeModal(e)}>
                      {lang.Confirm}
                    </div>
                  </div>
                </div>
              )}
              {/* <div className="close_btn_root">
                <img
                  src="/img/app/duid2/close_icon_btn.png"
                  className="in-mus-img"
                  onClick={(e) => this.closeModal(e)}
                ></img>
              </div> */}
            </div>

            {showWhiteModal && (
              <div className="submnit-click">
                <div className="confirm-pop-up">
                  <div className="title-tips"></div>
                  <div className="show-realy-duid">
                    <div className="top">{lang.sureYourChoose}</div>
                    <div className="duid">{speakList[selectSpeakIndex]}</div>
                  </div>
                  <div className="sunmi-btn">
                    <div
                      className="in-cancle"
                      onClick={() => this.setState({ showWhiteModal: false })}
                    >
                      {lang.Cancel}
                    </div>
                    <div className="in-confirm" onClick={() => this.getSpeakIdReqset()}>
                      {lang.Confirm}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/duid/index.js